import { render } from "./Loading.vue?vue&type=template&id=a53cf4b8&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=a53cf4b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a53cf4b8"

export default script